import FirstScreen from './screens/firstScreen/firstScreen';
import SecondScreen from './screens/secondScreen/secondScreen';
import ThirdScreen from './screens/thirdScreen/thirdScreen';
import FourthScreen from './screens/fourthScreen/fourthScreen';
import CoursesScreen from './screens/coursesScreen/coursesScreen';
import PerksScreen from './screens/perksScreen/perksScreen';
import CalculatorScreen from './screens/calculatorScreen/calculatorScreen';
import FitVsScreen from './screens/fitVsScreen/fitVsScreen';
import WhyNowScreen from './screens/whyNowScreen/whyNowScreen';
import FaqScreen from './screens/faqScreen/faqScreen';
import ShortsScreen from './screens/shortsScreen/shortsScreen';
import SocialProofScreen from './screens/socialProofScreen/socialProofScreen';
import Footer from './components/footer/Footer';
import WhatsAppFab from './components/whatsappFab/WhatsAppFab';
import Navbar from './components/nav/nav';

function Wrapper() {
  return (
    <div className="wrapper">
      <Navbar />
      <FirstScreen />
      <SecondScreen />
      <ThirdScreen />
      <SocialProofScreen />
      <FourthScreen />
      <CoursesScreen />
      <PerksScreen />
      <CalculatorScreen />
      <FitVsScreen />
      <WhyNowScreen />
      <FaqScreen />
      <ShortsScreen />
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export default Wrapper;
